<div class="option-text">Toggle User Options</div>
<nb-toggle  [checked]="true" disabled labelPosition="start">Search</nb-toggle>
<nb-toggle [checked]="true" labelPosition="start">User Account</nb-toggle>
<nb-toggle [checked]="true" disabled labelPosition="start">Shopping Cart</nb-toggle>
<nb-toggle [checked]="true" labelPosition="start">Wish List</nb-toggle>
<nb-toggle [checked]="true" labelPosition="start">User Notifications</nb-toggle>

